module.exports = __webpack_public_path__ + "static/media/logotipoHealth.b6f4ad6a.svg";